
import { Banner } from "../../util/Banner"
import { Link } from "react-router-dom"
import { useTranslation } from "react-i18next"
import buttonStyle from "../../../style/button.module.css"
import style from "./Home.module.css"
import pricing_cat from "../../../res/cat_w_gradient.png"

// Helper: emphasize uppercase letters (DE/EN including ÄÖÜ) in the tagline
const emphasizeCaps = (text) =>
  text
    .split(/([A-ZÄÖÜ])/g)
    .map((part, i) => (/[A-ZÄÖÜ]/.test(part) ? <strong key={i}>{part}</strong> : part))

export const Home = () => {
  const { t } = useTranslation(["table", "common", "page_names"])

  return (
    <>
      <Banner />

      {/* HERO */}
      <section className={style.hero} aria-label={t("common:home_intro")}>
        {/* Left column: headline, tagline, CTAs */}
        <div className={style.heroContent}>
          <h1 className={style.heroTitle}>
            {t("common:home_intro")}
          </h1>

          <p className={style.heroSubtitle} aria-label={t("common:home_acronym_descr")}>
            {emphasizeCaps(t("common:home_acronym_descr"))}
          </p>

          {/* 2×2 grid of equal-width buttons */}
          <div className={style.ctaGrid}>
            <Link to="/pricing_lists/" className={style.ctaLink}>
              <button className={buttonStyle.orangeButton}>
                {t("table:pricing_lists")}
              </button>
            </Link>

            <Link to="/plausibility_checks/" className={style.ctaLink}>
              <button className={buttonStyle.orangeButton}>
                {t("table:plausibility_checks")}
              </button>
            </Link>

            <Link to="/ifa_changes/" className={style.ctaLink}>
              <button className={buttonStyle.orangeButton}>
                {t("page_names:ifa_changes")}
              </button>
            </Link>

            <Link to="/run_info/" className={style.ctaLink}>
              <button className={buttonStyle.orangeButton}>
                {t("table:run_info")}
              </button>
            </Link>
          </div>
        </div>

        {/* Right column: cat image (frameless) */}
        <div className={style.heroImageWrapper}>
          <img
            src={pricing_cat}
            alt={t("hero.alt", "PUMA mascot cat")}
            className={style.heroImage}
          />
        </div>
      </section>
    </>
  )
}
